/**
 * Client-side CMS queries. Every read goes to the database so the storefront
 * always renders the latest published content and the admin always edits the
 * latest saved content.
 */
import { queryOptions } from "@tanstack/react-query";
import {
  getPublishedCmsPageFn,
  getCmsPageFn,
  listCmsPagesFn,
} from "./cms.functions";
import type { CmsPage } from "@/lib/admin/cms/store";

export const publishedCmsPageQuery = (slug: string) =>
  queryOptions({
    queryKey: ["cms", "published", slug],
    queryFn: () => getPublishedCmsPageFn({ data: { slug } }) as Promise<CmsPage | null>,
    staleTime: 0,
  });

export const adminCmsPageQuery = (slug: string) =>
  queryOptions({
    queryKey: ["cms", "admin", slug],
    queryFn: () => getCmsPageFn({ data: { slug } }) as Promise<CmsPage | null>,
    staleTime: 0,
  });

export const adminCmsPagesQuery = () =>
  queryOptions({
    queryKey: ["cms", "admin", "list"],
    queryFn: () => listCmsPagesFn() as Promise<CmsPage[]>,
    staleTime: 0,
  });
